document.addEventListener('DOMContentLoaded', function () {
	
  	let buttons = document.querySelectorAll('.btn-location');
  	let dropdown = document.querySelector('.dropdown-content-desktop');
  	let dropdownMobile = document.querySelector('.dropdown-content-mobile');

  	buttons.forEach(function (btn, index) {
      var clone1 = btn.cloneNode(true);
      clone1.classList.remove('slt4_btn', 'button', 'wcustom_40', 'btn_icon_false');
      var clone2 = btn.cloneNode(true);
      clone2.classList.remove('slt4_btn', 'button', 'wcustom_40', 'btn_icon_false');
      
      if(dropdown){
      	dropdown.appendChild(clone1);
      }
      
      if(dropdownMobile){
      	dropdownMobile.appendChild(clone2);
      }
	});
  
  	buttons = document.querySelectorAll('.btn-location');
  	const age_agree = document.getElementById('age_agree');
    const error_message = document.getElementById('error-message');
  
  	buttons.forEach(el => el.addEventListener('click', event => {
      var url = "#";
      if(event.target.classList.contains('slt4_btn')){
          if(age_agree.checked){
            error_message.style.display = 'none';
            updateCartAttr(event.target.getAttribute("data-loc"), event.target.getAttribute("data-locid"), event.target.getAttribute("data-locname"), url);
          } else {
            error_message.style.display = 'block';
          }
      } else {
      	updateCartAttr(event.target.getAttribute("data-loc"), event.target.getAttribute("data-locid"), event.target.getAttribute("data-locname"), url);
      }
      
    }));
  
    if(isMobile.any()){
      	let ddm = document.querySelector(".dropdown");
      	
      	ddm.addEventListener('touchstart', function(event) {
          	toggleVisibility(".dropdown-content");
        }, false);
    }
  
  
  	var modals = document.querySelectorAll('[data-modal]');

    modals.forEach(function(trigger) {
      trigger.addEventListener('click', function(event) {
        
        event.preventDefault();
        var modal = document.getElementById(trigger.dataset.modal);
        modal.classList.add('open');
        var exits = modal.querySelectorAll('.modal-exit');
        exits.forEach(function(exit) {
          exit.addEventListener('click', function(event) {
            event.preventDefault();
            modal.classList.remove('open');
          });
        });
      });
    });
  
  	if(locationName){
    	//console.log("locationName:" + locationName);
      	$("#bt-city-ddm").text("Ciudad de entrega: " + locationName);
    }
  
}, false);

function updateCartAttr(locationCode, locationId, locationName, url){
  fetch("".concat("/cart", "/update.js"), {
    body: JSON.stringify({
      attributes: {
        'location': locationCode,
        'locationId': locationId,
        'locationName': locationName
      }
    }),
    credentials: 'same-origin',
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest' // This is needed as currently there is a bug in Shopify that assumes this header

    }
  }).then(function (response) {
      if(url == "#"){
		location.reload();
      } else {
      	//location.href = url;
        location.reload();
      }
  });
}


var isMobile = {
    Android: function() {
        return navigator.userAgent.match(/Android/i);
    },
    BlackBerry: function() {
        return navigator.userAgent.match(/BlackBerry/i);
    },
    iOS: function() {
        return navigator.userAgent.match(/iPhone|iPad|iPod/i);
    },
    Opera: function() {
        return navigator.userAgent.match(/Opera Mini/i);
    },
    Windows: function() {
        return navigator.userAgent.match(/IEMobile/i);
    },
    any: function() {
        return (isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.Opera() || isMobile.Windows());
    }
};


function toggleVisibility(id) {
  var e = document.querySelector(id);
  if(e.style.display == 'block') {
    e.style.display = 'none';
  }
  else {
    e.style.display = 'block';
  }
  
  return;
}

function getInventoryByLocation(variantId, locationId, parameters, callback){
    var shopId = Shopify.shop;  
    var url1 = "https://"+shopId+"/admin/api/2021-04/variants/"+variantId+".json"
    console.log("inve");

    var query = {
      "query": 'query {productVariants(first: 1, query: "id:'+variantId+'") { edges { node { id  inventoryItem  { id inventoryLevel (locationId:"gid://shopify/Location/'+locationId+'") {id available }} } } }}'
    };

    fetch('https://'+shopId+'/admin/api/2020-04/graphql.json', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Shopify-Access-Token':"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"
      },
      body: JSON.stringify(query)
    })
    .then(r => r.json())
    .then(data => {
      console.log(data);
      var quantity = 0;
      
      try {
        quantity= data.data.productVariants.edges[0].node.inventoryItem.inventoryLevel.available;
      } catch (error) {
        console.log(error);
        quantity= 0;
      }

      callback(quantity);
    });

  	/*
    $.ajax({
      url: urlVariant,
      type: 'GET',
      beforeSend: function (xhr) {
        xhr.setRequestHeader('Authorization', 'Bearer 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');
      },
      data: {},
      success: function (variant) {
        var inventory_item_id =variant.variant.inventory_item_id;
        var url = "https://"+shopId+"/admin/api/2021-04/inventory_levels.json?inventory_item_ids=" + inventory_item_id +"&location_id="+ locationId;

        $.ajax({
          url: url,
          type: 'GET',
          beforeSend: function (xhr) {
            xhr.setRequestHeader('Authorization', 'Bearer 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');
          },
          data: {},
          success: function (data) {
            console.log(data);
            var quantity = 0;
            var inventory = data.inventory_levels

            if(inventory != null && inventory.length > 0){
              for(var i =0;i< inventory.length; i++){
                let location = inventory[i];

                if(location.inventory_item_id == inventory_item_id && location.location_id ==locationId){
                  quantity= location.available;
                  break;
                }
              }
            }

            if(callback){
            	callback(data);
            }
          },
          error: function (msg) {
            console.log(msg);
            if(callback){
            	callback(0);
            }
          },
        });   
      },
      error: function (msg) {
        if(callback){
            	callback(0);
            }
      }
    });*/
  }